import React from 'react'
import { Blockquote } from './Blockquote.d'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { Heading } from '@toasttab/shared/src/components'
import classNames from 'classnames'
import { getImage } from '@toasttab/shared/src/utils/siteUtils'

const BlockquoteModule = (blockquote: Blockquote) => {
  const sectionCss = classNames({
    'otl-blockquote': true,
    'w-full mt-3 py-7': true
  })

  const headshot = getImage(blockquote.authorImage)

  return (
    <section className={sectionCss}>
      <div className='px-4 md:px-14'>
        <div className='border-l-2 border-solid border-black py-1 pl-7 pr-4'>
          <Heading
            classes='mb-6'
            color={['text-default']}
            fontFamily='font-calibre'
            fontWeight='font-semibold'
            letterSpacing='tracking-normal'
            textAlign={['text-left']}
            width='w-full'
            fontSize={['text-xl']}
            content={blockquote.quote?.quote}
            heading='h3'
          />
          <div>
            <div className='flex items-center'>
              {headshot && headshot.url && headshot.title && (
                <div className='min-w-[40px] max-w-[40px] overflow-hidden rounded-[50%] mr-5 max-h-[42px]'>
                  <Image {...headshot} />
                </div>
              )}
              <div>
                {blockquote.author && (
                  <Heading
                    classes='uppercase'
                    color={['text-otl-orange']}
                    fontFamily='font-calibre'
                    fontWeight='font-semibold'
                    letterSpacing='tracking-normal'
                    textAlign={['text-left']}
                    width='w-full'
                    fontSize={['text-sm']}
                    content={blockquote.author}
                    heading='h5'
                  />
                )}
                {blockquote.authorTitle && (
                  <Heading
                    classes='uppercase'
                    color={['text-otl-orange']}
                    fontFamily='font-calibre'
                    fontWeight='font-semibold'
                    letterSpacing='tracking-normal'
                    textAlign={['text-left']}
                    width='w-full'
                    fontSize={['text-sm']}
                    content={blockquote.authorTitle}
                    heading='h5'
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockquoteModule
